import { useCallback } from "react";
import { useUserInfo } from "@/context/PageStateContext";
import { login as baseLogin } from "@/lib/login";
import type { LoginOptions } from "@/types/api.d";
import { useToast } from "@/context/ToastContext";
import { Level, reportError } from "@/lib/owl";

type UseLoginOptions = Omit<LoginOptions, "isLoginExpired"> & {
  isLoginExpired?: boolean;
};

/**
 * 基于全局用户状态的登录 Hook，自动透传 isLoginExpired
 * 
 * 注意：
 * - H5环境：登录会跳转到登录页，登录成功后自动跳转回 backUrl，不会触发 onLoginSuccess
 * - APP环境：通过桥接登录，登录成功后会触发 onLoginSuccess，需要更新状态或刷新页面
 */
export function useLogin() {
  const { userInfo, setUserInfo } = useUserInfo();
  const toast = useToast();

  const login = useCallback(
    async (options: UseLoginOptions = {}): Promise<void> => {
      const runtimeBackUrl =
        options.backUrl ||
        (typeof window !== "undefined" ? window.location.href : "");
      const isExpired =
        options.isLoginExpired ?? Boolean(userInfo?.isLoginExpired);
      console.log("runTimeBackUrl", runtimeBackUrl);
      return baseLogin({
        ...options,
        backUrl: runtimeBackUrl,
        isLoginExpired: isExpired,
        onLoginSuccess: (res)=>{
          console.log("onLoginSuccess reload");
          // 和容器侧沟通 容器侧目前没有主动同步登陆态到cookie,刷新后会同步，业务先主动刷新（高达也有刷新
          // https://tt.sankuai.com/ticket/detail?id=332375136
          window.location.reload();
        },
        onLoginFail(error) {
          reportError({
            name: "[login] onLoginFail",
            msg: error,
            level: Level.WARN,
          })
          toast.show("登陆有误，请重新尝试");
        }
      });
    },
    [userInfo?.isLoginExpired, setUserInfo, toast]
  );

  return { login };
}

export default useLogin;

